/**
 * Application configuration
 * Environment variables are loaded from .env files
 */

const getApiUrl = () => {
  const envUrl = import.meta.env.VITE_API_BASE_URL;
  if (envUrl) {
    // Remove trailing slash if present
    return envUrl.replace(/\/$/, "");
  }
  return "http://localhost:8080";
};

export const config = {
  apiUrl: getApiUrl(),
  phishinApiUrl:
    import.meta.env.VITE_PHISHIN_API_URL || "https://phish.in/api/v2",
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};

if (typeof console !== "undefined") {
  console.info("[Config] API base URL:", config.apiUrl);
}

export default config;
